app.controller("EditSessionController", [
    "$scope", "Session", "TimetableService", "Lecturer", "$stateParams", "params", "StaticData", "$uibModalInstance", "toastr",
    function ($scope, Session, TimetableService, Lecturer, $stateParams, params, StaticData, $uibModalInstance, toastr) {
        $scope.activation = params.group.subjectActivation;
        $scope.title = params.group.title;
        $scope.duration = params.group.duration;
        $scope.chosenLecturer = params.group.lecturer;
        $scope.minStudents = params.group.minStudents;
        $scope.maxStudents = params.group.maxStudents;

        StaticData.getItemsByKey("session_types").then(function (types) {
            $scope.types = types;
            $scope.typesMap = _.keyBy(types, '_id');
            $scope.sessionType = $scope.typesMap[params.group.sessionType];
        });

        $scope.getLecturers = function (query) {
            if (query.length < 2) {
                return [];
            }
            return Lecturer.list({query: query}).then(function (data) {
                return data.docs;
            });
        };

        $scope.editSession = function () {
            if (!$scope.chosenLecturer) return toastr.error('', 'გთხოვთ მიუთითოთ ლექტორი');
            if (!$scope.duration) return toastr.error('', 'გთხოვთ მიუთითოთ საათების რაოდენობა');
            Session.edit({
                _id: params.group._id,
                lecturer: $scope.chosenLecturer._id,
                title: $scope.title,
                sessionType: $scope.sessionType._id,
                subjectActivation: $scope.activation._id,
                subjectWrapper: $scope.activation.subjectWrapper,
                subject: $scope.activation,
                minStudents: $scope.minStudents,
                maxStudents: $scope.maxStudents,
                duration: $scope.duration
            }).then(function (result) {
                toastr.success('ჯგუფი რედაქტირებულია');
                $uibModalInstance.close();
            })
        };

        $scope.close = function () {
            $uibModalInstance.dismiss();
        };
    }
]);